import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MemberInvite, QueryMemberInviteArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TData = MemberInvite;
type TVariables = QueryMemberInviteArgs;

const MOCK: TVariables = { token: '' };

export const useMemberInvite = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query getMemberInvite($token: String!) {
      memberInvite(token: $token) {
        email
        companyName
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['memberInvite', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
